var _class, _descriptor, _calendarSchools, _coursesSchools, _learnerGroupSchools, _learnerGroupCohorts, _courses, _courseSessions;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { service } from '@ember/service';
let DataLoaderService = (_class = (_calendarSchools = /*#__PURE__*/new WeakMap(), _coursesSchools = /*#__PURE__*/new WeakMap(), _learnerGroupSchools = /*#__PURE__*/new WeakMap(), _learnerGroupCohorts = /*#__PURE__*/new WeakMap(), _courses = /*#__PURE__*/new WeakMap(), _courseSessions = /*#__PURE__*/new WeakMap(), class DataLoaderService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _classPrivateFieldInitSpec(this, _calendarSchools, {});
    _classPrivateFieldInitSpec(this, _coursesSchools, {});
    _classPrivateFieldInitSpec(this, _learnerGroupSchools, null);
    _classPrivateFieldInitSpec(this, _learnerGroupCohorts, {});
    _classPrivateFieldInitSpec(this, _courses, {});
    _classPrivateFieldInitSpec(this, _courseSessions, {});
  }
  async loadSchoolForCalendar(id) {
    if (!(id in _classPrivateFieldGet(_calendarSchools, this))) {
      const relationships = ['programs.programYears.cohort', 'sessionTypes', 'vocabularies.terms.children.children.children', 'courses'];
      const include = relationships.join(',');
      _classPrivateFieldGet(_calendarSchools, this)[id] = this.store.findRecord('school', id, {
        include,
        reload: true
      });
    }
    return _classPrivateFieldGet(_calendarSchools, this)[id];
  }
  async loadSchoolForCourses(id) {
    // more comprehensive so if we already have it then use it.
    if (id in _classPrivateFieldGet(_calendarSchools, this)) {
      return _classPrivateFieldGet(_calendarSchools, this)[id];
    }
    if (!(id in _classPrivateFieldGet(_coursesSchools, this))) {
      const relationships = ['sessionTypes', 'vocabularies.terms.children.children.children', 'courses', 'configurations'];
      const include = relationships.join(',');
      _classPrivateFieldGet(_coursesSchools, this)[id] = this.store.findRecord('school', id, {
        include,
        reload: true
      });
    }
    return _classPrivateFieldGet(_coursesSchools, this)[id];
  }
  async loadSchoolsForLearnerGroups() {
    if (!_classPrivateFieldGet(_learnerGroupSchools, this)) {
      _classPrivateFieldSet(_learnerGroupSchools, this, this.store.findAll('school', {
        include: 'programs.programYears.cohort',
        reload: true
      }));
    }
    return _classPrivateFieldGet(_learnerGroupSchools, this);
  }
  async loadCohortForLearnerGroups(id) {
    if (!(id in _classPrivateFieldGet(_learnerGroupCohorts, this))) {
      _classPrivateFieldGet(_learnerGroupCohorts, this)[id] = this.store.findRecord('cohort', id, {
        include: 'learnerGroups,users',
        reload: true
      });
    }
    return _classPrivateFieldGet(_learnerGroupCohorts, this)[id];
  }
  async loadCourse(id) {
    if (!(id in _classPrivateFieldGet(_courses, this))) {
      const relationships = ['clerkshipType', 'courseObjectives.programYearObjectives', 'courseObjectives.meshDescriptors', 'courseObjectives.terms.vocabulary', 'courseObjectives.programYearObjectives.competency', 'learningMaterials.learningMaterial.owningUser', 'directors', 'administrators', 'studentAdvisors', 'meshDescriptors.trees', 'cohorts.programYear.program', 'cohorts.programYear.programYearObjectives', 'cohorts.learnerGroups', 'ancestor', 'descendants', 'terms.vocabulary', 'terms.parent.parent.parent'];
      const include = relationships.join(',');
      _classPrivateFieldGet(_courses, this)[id] = this.store.findRecord('course', id, {
        include,
        reload: true
      });
    }
    return _classPrivateFieldGet(_courses, this)[id];
  }
  async loadCourseSessions(id) {
    if (!(id in _classPrivateFieldGet(_courseSessions, this))) {
      const sessionRelationships = ['learningMaterials.learningMaterial.owningUser', 'sessionObjectives.courseObjectives', 'sessionObjectives.meshDescriptors', 'sessionObjectives.terms.vocabulary', 'offerings.learners', 'offerings.instructors', 'offerings.instructorGroups.users', 'offerings.learnerGroups.users', 'ilmSession.learners', 'ilmSession.instructors', 'ilmSession.instructorGroups.users', 'ilmSession.learnerGroups.users', 'meshDescriptors.trees', 'administrators', 'studentAdvisors'];
      const sessionIncludes = sessionRelationships.reduce((includes, item) => {
        return `${includes}${item},`;
      }, '');
      _classPrivateFieldGet(_courseSessions, this)[id] = this.store.query('session', {
        filters: {
          course: id
        },
        include: sessionIncludes
      });
    }
    return _classPrivateFieldGet(_courseSessions, this)[id];
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DataLoaderService as default };